import React from 'react'
import Provider from './Context'
import Home from './components/Home'

export default function App() {
  return (
    <Provider>
      <Home />
    </Provider>
  )
}
